import { createFileRoute } from '@tanstack/react-router';
import { FichaPage } from '@/components/ficha-tecnica';

export const Route = createFileRoute('/_app/custos/fichas-tecnicas/$id')({
  component: FichaRota,
});

function FichaRota() {
  const { id } = Route.useParams();
  return <FichaPage key={id} id={id} />;
}
